import UserAPI from './UserAPI';

export const getUserSelector = (userId: string) =>
  UserAPI.endpoints.getUser.select(userId);
